<div class="wrap">
	<div class="card-button-group">
		<button class="button-general" [disabled]="!hasDataChange" (click)="discard()">Discard</button>
		<button class="button-general" [disabled]="!checkCommitable()" (click)="commit()">Commit</button>
	</div>
	<div class="feed-groups">
		<app-resolution-aoe *ngIf="aoeFeed" #aoeTemplate [resolverFeed]="aoeFeed" (edit)="onEdit($event)"></app-resolution-aoe>
		<app-resolution-asq *ngIf="asqFeed" #asqTemplate [resolverFeed]="asqFeed" (edit)="onEdit($event)"></app-resolution-asq>
		<app-resolution-dav *ngIf="davFeed" #davTemplate [resolverFeed]="davFeed" (edit)="onEdit($event)"></app-resolution-dav>
		<ng-container *ngIf="raoFeeds">
			<ng-container *ngFor="let raoFeed of raoFeeds">
				<app-resolution-rao #raoTemplate [resolverFeed]="raoFeed" (edit)="onEdit($event)"></app-resolution-rao>				
			</ng-container>
		</ng-container>
		<!-- <app-resolution-rao *ngIf="raoFeeds" #raoTemplates [resolverFeed]="raoFeeds[0]" (edit)="onEdit($event)"></app-resolution-rao>				 -->

		<app-resolution-cad *ngIf="cadFeed" #cadTemplate [resolverFeed]="cadFeed"></app-resolution-cad>
	</div>
</div>